import { useState } from "react";
import { BlogSubscriptionPopup } from "./BlogSubscriptionPopup.jsx";

export function BlogSubscription({ configuration }) {
  const [isPopupOpen, setPopupOpen] = useState(false);

  const openPopup = () => {
    setPopupOpen(true);
  };

  return (
    <div className="card w-100 p-4 shadow-sm card-border-left min-height-16em height-100 d-flex flex-column align-items-start justify-content-center">
      <div className="d-flex flex-column align-items-start align-items-md-center justify-content-center w-100">
        <h3 className="h4 text-start text-md-center w-100">
          {configuration.translations.blogSubscriptionTitle}
        </h3>
        <p className="text-start text-md-center">{configuration.translations.blogSubscriptionDescr}</p>
        <button
          className="btn btn-primary"
          onClick={(e) => {
            e.preventDefault();
            openPopup();
          }}
        >
          {configuration.translations.subscribeButton}
        </button>
        {isPopupOpen && (
          <BlogSubscriptionPopup
            configuration={configuration}
            onHide={() => setPopupOpen(false)}
            show={isPopupOpen}
          />
        )}
      </div>
    </div>
  );
}
